import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AdminDetail from './components/AdminDetail.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageAdmin',
  components: {
    AdminDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;